export const client = [
    {
        id: 0,
        name: "Geral de Faturamento",
        description: "Relatório geral análitico com as informações de faturamento do estabelecimento.",
        code: "geral_de_faturamento"
    },
    {
        id: 1,
        name: "Giro de Vagas",
        description: "Relatório com a quantidade de clientes por dia e faixa horária no estabelecimento.",
        code: "giro_de_vagas"
    },
    {
        id: 2,
        name: "Tempo Médio de Permanência",
        description: "Relatório com o tempo médio de permanência dos clientes por dia, mês, trimestre, semestre ou ano.",
        code: "tempo_medio_permanencia"
    },
    {
        id: 3,
        name: "Perfil dos clientes",
        description: "Relatório com a quantidade de clientes rotativos (avulsos e do app), e mensalistas.",
        code: "perfil_dos_clientes"
    }
]